import { httpClient } from '@/services/http/httpClient'

export type TennantConfig = {
  id: string
  tennantId: string
  isPublicIdeas: boolean
  isAuthByPass: boolean
  hasPowerBi: boolean
  hasChatbot: boolean
  msalClientId: string | null
  msalAuthority: string | null
  msalRedirectUri: string | null
  msalGroupId: string | null
  msalClientSecret: string | null
  hasProjectModule: boolean
  hasOpenInnovationModule: boolean
  msalUseAreaUsers: boolean
  hasAIService: boolean
  maxUsers: number | null
  hasEmailNotifications: boolean
  hasInAppNotifications: boolean
  createdAt: string
}

type Tennant = {
  id: string
  name: string
  slug: string
  status: string
  createdAt: string
  config: TennantConfig
}

type GetTennantsResponse = {
  tennants: Tennant[]
}

export async function getTennants(): Promise<GetTennantsResponse> {
  const { data } = await httpClient.get<GetTennantsResponse>('/tennants/')

  return data
}
